export enum OfferingIntent {
  SHOW_DETAILS = 'showDetails',
  BOOK_OFFERING = 'bookOffering',
}

export enum NavigationTarget {
  CALENDAR = 'calendar',
  SERVICE_PAGE = 'servicePage',
}
